import {
  BOOKING_INQUIRY_SET_FILTER,
  BOOKING_INQUIRY_RESET_FILTER,
  BOOKING_INQUIRY_PAGINATION,
  BOOKING_INQUIRY_ENABLE_LOADING,
  BOOKING_INQUIRY_DISABLE_LOADING,
  BOOKING_INQUIRY_UPDATE_DATA,
  BOOKING_INQUIRY_GET_STATUS_WISE_COUNT,
  BOOKING_INQUIRY_APPLY_FILTER,
  BOOKING_INQUIRY_CANCEL_FILTER,
  BOOKING_INQUIRY_SET_PREV_PAGINATION,
  UPDATE_INTTRA_CODE_IN_INQUIRY_MASTER_DATA,
  BOOKING_INQUIRY_RESET_PAGINATION,
} from './constants';
import {
  fetchAllBookingShipper,
  fetchAllBookingFF,
  fetchBookingInquiryStatusWiseCountForShipper,
  fetchBookingInquiryStatusWiseCountForFF,
} from 'src/api/booking';
import { getLastSortedColumnValue } from 'src/utils/pagination';
import { isValidString } from 'src/Library/Helper';

export const bookingSetFilter = (type) => (val, applyFilter = false) => async (dispatch) => {
  dispatch({
    type: BOOKING_INQUIRY_SET_FILTER,
    data: val,
  });
  if (applyFilter) {
    dispatch({
      type: BOOKING_INQUIRY_APPLY_FILTER,
    });
    dispatch(fetchAllBookings(type));
  }
};

export const cancelFilter = (type) => () => async (dispatch) => {
  dispatch({
    type: BOOKING_INQUIRY_CANCEL_FILTER,
  });
};

export const bookingApplyFilter = (type) => (noRender = false) => async (dispatch) => {
  dispatch({
    type: BOOKING_INQUIRY_APPLY_FILTER,
  });
  if (!noRender) {
    dispatch(fetchAllBookings(type));
  }
};

export const bookingResetFilter = (type) => (hitApi = false) => async (dispatch) => {
  dispatch({
    type: BOOKING_INQUIRY_RESET_FILTER,
  });
  if (!hitApi) {
    dispatch(fetchAllBookings(type));
  }
};

export const bookingResetFilterWithOutAPI = (type) => () => async (dispatch) => {
  dispatch({
    type: BOOKING_INQUIRY_RESET_FILTER,
  });
  dispatch(fetchAllBookings(type));
};

export const bookingSetPagination = (type) => (val) => async (dispatch) => {
  dispatch({
    type: BOOKING_INQUIRY_PAGINATION,
    data: val,
  });
  dispatch(fetchAllBookings(type));
};

export const setPrevPagination = (type) => () => async (dispatch, getState) => {
  dispatch({
    type: BOOKING_INQUIRY_SET_PREV_PAGINATION,
  });
  dispatch(fetchAllBookings(type));
};

export const updateInttraCodeInMasterData = (val) => async (dispatch) => {
  if (isValidString(val)) {
    dispatch({
      type: UPDATE_INTTRA_CODE_IN_INQUIRY_MASTER_DATA,
      data: val,
    });
  }
};

export const fetchAllBookings = (type) => async (dispatch, getState) => {
  if (type) {
    dispatch({
      type: BOOKING_INQUIRY_ENABLE_LOADING,
    });
    const appliedFilters = getState().bookingInquiryReducer.appliedFilters;
    // For Filters
    const polList = appliedFilters.polList?.length
      ? appliedFilters.polList.map((filter) => filter.key)
      : [];
    const podList = appliedFilters.podList?.length
      ? appliedFilters.podList.map((filter) => filter.key)
      : [];
    const ffList = appliedFilters.ffList ? appliedFilters.ffList : [];
    const ffGroupIdList = appliedFilters.ffGroupIdList ? appliedFilters.ffGroupIdList : [];
    const shipperList = appliedFilters.shipperList ? appliedFilters.shipperList : [];
    const statusList = appliedFilters.statusList;
    const sourceObjectIdList = appliedFilters.inquiryIdList ? [appliedFilters.inquiryIdList] : [];
    const bookingIdList = appliedFilters.bookingIdList ? [appliedFilters.bookingIdList] : [];
    const descendingOrder = appliedFilters.descendingOrder;
    const modeList = appliedFilters.modeList ? appliedFilters.modeList : [];
    const showActiveInttraBookings = appliedFilters.showActiveInttraBookings;
    const inttraStatusList = appliedFilters.inttraStatusList;

    const pagination = getState().bookingInquiryReducer.pagination;

    const originCityList = appliedFilters?.originCityList?.length ? appliedFilters.originCityList.map(filter => filter.key) : [];
    const destinationCityList = appliedFilters?.destinationCityList?.length ? appliedFilters.destinationCityList.map(filter => filter.key) : [];
    const originCountryList = appliedFilters.originCountryList?.length ? appliedFilters.originCountryList.map(filter => filter.key) : [];
    const destinationCountryList = appliedFilters.destinationCountryList?.length ? appliedFilters.destinationCountryList.map(filter => filter.key) : [];

    const body = {
      sourceObjectIdList,
      bookingIdList,
      polList,
      podList,
      statusList,
      descendingOrder,
      modeList,
      orgIdList: type === 'SHIPPER' ? ffList : shipperList,
      ffGroupIdList,
      internalReferenceNumberList: appliedFilters.internalReferenceNumberList,
      sortBy: appliedFilters.sortBy,
      lastBookingRequestId: getLastColumnId(pagination),
      lastSortedColumnValue: getLastSortedColumnValue(pagination),
      currentPageNumber: pagination.currentPageNumber,
      resultPerPage: Number(pagination.resultPerPage),
      nextOrPrev: pagination.nextOrPrev,
      ...(type === 'FF' && {
        showActiveInttraBookings,
        inttraStatusList,
      }),
      accessTypes: appliedFilters.accessTypeFilters,
      originCityList,
      destinationCityList,
      originCountryList,
      destinationCountryList,
    };
    let response;
    if (type === 'SHIPPER') {
      response = await fetchAllBookingShipper(body);
    } else {
      response = await fetchAllBookingFF(body);
    }
    if (response.isSuccess) {
      dispatch({
        type: BOOKING_INQUIRY_UPDATE_DATA,
        data: response.response,
      });
    } else {
    }

    let responseIC;
    const bodyForCount = {
      modeList: body.modeList,
      polList: body.polList,
      podList: body.podList,
      internalReferenceNumberList: body.internalReferenceNumberList,
      bookingIdList: body.bookingIdList,
      orgIdList: body.orgIdList,
      ...(type === 'FF' && {
        showActiveInttraBookings,
      }),
      accessTypes: appliedFilters.accessTypeFilters,
      originCityList,
      destinationCityList,
      originCountryList,
      destinationCountryList,
    };

    if (type === 'SHIPPER') {
      responseIC = await fetchBookingInquiryStatusWiseCountForShipper({
        ...bodyForCount,
        bookingView: 'SHIPPER',
      });
    } else {
      responseIC = await fetchBookingInquiryStatusWiseCountForFF({
        ...bodyForCount,
        bookingView: 'FF',
      });
    }
    if (responseIC.isSuccess) {
      dispatch({
        type: BOOKING_INQUIRY_GET_STATUS_WISE_COUNT,
        data: responseIC.response,
      });
    }

    dispatch({
      type: BOOKING_INQUIRY_DISABLE_LOADING,
    });
  } else {
    throw new Error('Type cannot be null');
  }
};

const getLastColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};
